import { Translate } from "@/components/common/Translate/Translate";
import { useBulkResizerFlipSettings } from "./useBulkResizerFlipSettings";
import { HorizontalIcon } from "components/common/Icons/HorizontalIcon";
import { VerticalIcon } from "components/common/Icons/VerticalIcon";
import { Loader } from "@/components/common/Icons/Loader/Loader";

interface BulkResizerFlipSettingsProps {
    imageId: string;
}

export const BulkResizerFlipSettings = ({ imageId }: BulkResizerFlipSettingsProps) => {
    const { handleHorizontalToggle, handleVerticalToggle, flippingState } = useBulkResizerFlipSettings(imageId);

    return (
        <div className="flex flex-col px-4">
            <div className="text-white font-semibold text-lg mb-4">
                <Translate keyName="flip-image" />
            </div>
            <div className="flex items-center gap-4 select-none">
                <div
                    className="flex-grow text-center w-full"
                    onClick={handleHorizontalToggle}
                    data-testid="flip-horizontal"
                >
                    <div
                        className={`dark:bg-darkSurface-200 cursor-pointer w-full flex items-center justify-center rounded-2xl border-slate-200 dark:border-darkSurface-400 border py-4 md:py-8 my-2`}
                    >
                        {flippingState === "horizontal" ? (
                            <Loader className="stroke-[var(--dark-gray)]" height={34} width={34} />
                        ) : (
                            <HorizontalIcon />
                        )}
                    </div>
                    <div className="font-sembold md:text-xl capitalize">
                        <Translate keyName="horizontally" />
                    </div>
                </div>
                <div
                    className="flex-grow text-center w-full"
                    onClick={handleVerticalToggle}
                    data-testid="flip-vertical"
                >
                    <div
                        className={`dark:bg-darkSurface-200 cursor-pointer w-full flex items-center justify-center rounded-2xl border-slate-200 dark:border-darkSurface-400 border py-4 md:py-8 my-2`}
                    >
                        {flippingState === "vertical" ? (
                            <Loader className="stroke-[var(--dark-gray)]" height={34} width={34} />
                        ) : (
                            <VerticalIcon />
                        )}
                    </div>
                    <div className="font-sembold md:text-xl capitalize">
                        <Translate keyName="vertically" />
                    </div>
                </div>
            </div>
        </div>
    );
};
